import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Omförhandling from "../DatePicker/Omförhandling";
import Slutdatum from "../DatePicker/Slutdatum";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import AvtalsTyp from "./Input/AvtalsTyp";
import Leverantör from "./Input/Leverantör";
import PrislistaInput from "./Input/PrislistaInput";
import SelectMedArbetare from "../SkapaMote/Inputs/SelectMedArbetare";
import Button from "@material-ui/core/Button";
import moment from 'moment';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function InputComponent(props) {
    const classes = useStyles();
    const [state, setstate] = React.useState(props.newAvtal.Avtal);
    const [avtalType, setavtalType] = React.useState(0);
    const [disabled, setDisabled] = React.useState(false);
    let Description = props.intl.formatMessage({ id: 'appKontoModule.Description' });
    let Expires = props.intl.formatMessage({ id: 'Expires' });
    let InputStartDate = props.intl.formatMessage({ id: 'input.Date.Start' });
    const handleDisable = (e) => {
        setDisabled(!disabled)
    };

    const getAVtalType = (avtaltype)=>{
        setstate({ ...state, avtaltyp: avtaltype });
        setavtalType(avtaltype);
        props.SetAvtalParameters({ ...state, avtaltyp: avtaltype })
    }
    const getAVtalLeverator = (Leverantor)=>{
        setstate({ ...state, Leverantor: Leverantor });
        props.SetAvtalParameters({ ...state, Leverantor: Leverantor })
    }
    const getAVtalAnavarig = (ansvarig)=>{
        setstate({ ...state, Ansvarig: ansvarig });
        props.SetAvtalParameters({ ...state, Ansvarig: ansvarig })
    }
    const PrisListIdChange = (name,Value)=>{
        setstate({ ...state, [name]: Value });
        props.SetAvtalParameters({ ...state, [name]: Value })
        props.SetPrisListaParameters(Value)

    }
    const SluthandleChange = (date)=>{
        let ddate= moment(date).format("YYYY-MM-DD HH:mm");
        setstate({ ...state, Slutdatum: ddate });
        props.SetAvtalParameters({ ...state, Slutdatum: ddate })
    }
    const StarthandleChange = (date)=>{
        let ddate= moment(date).format("YYYY-MM-DD HH:mm");
        setstate({ ...state, StartDate: ddate });
        props.SetAvtalParameters({ ...state, StartDate: ddate })
    }
    const OmforhandleChange = (date)=>{
        let ddate= moment(date).format("YYYY-MM-DD HH:mm");
        setstate({ ...state, Omforhandle: ddate });
        props.SetAvtalParameters({ ...state, Omforhandle: ddate })
    }
    const handleChangeR = (event)=>{
        setstate({ ...state, [event.target.name]: event.target.value });
    }
    const handleBlurR = (event)=>{
        props.SetAvtalParameters(state)
    }
    const handleChange = (event) => {
        setstate({ ...state, [event.target.name]: (event.target.checked===true)?1:0 });
        props.SetAvtalParameters({ ...state, [event.target.name]: (event.target.checked===true)?1:0 })
    };
    React.useEffect(()=>{
        if(props.newAvtal.Avtal !== state){
            setstate(props.newAvtal.Avtal)
        }
    },[props.newAvtal.Avtal])
    return (
        <div>
            <form className={classes.root}>
                <div className="d-flex my-2"  style={{ height: 'auto' }}>
                    <div>
                        <p style={{ marginTop: '7px', marginRight: '1rem' }}><IntlMessages id="Input.onGoing"/></p>
                    </div>
                    <div>
                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={(state.Laperut===1)?true:false}
                                        onChange={handleChange}
                                        name="Laperut"
                                        color="primary"
                                    />
                                }
                            />
                        </FormGroup>
                    </div>
                </div>
                <div>
                    <div className={`row my-2`} style={{ height: 'auto' }}>
                        <div className="col-4">
                            <Slutdatum lable={InputStartDate} handleChange={StarthandleChange}/>
                        </div>
                        <div className="col-4">
                            <Slutdatum lable={Expires} disabled={state.Laperut===1} handleChange={SluthandleChange}/>
                        </div>
                        <div className="col-4">
                            <Omförhandling disabled={state.Laperut===1}  handleChange={OmforhandleChange}/>
                        </div>
                    </div>
                    <div className="row  my-2"  style={{ height: 'auto' }}>
                        <div className="col-6">
                        <AvtalsTyp 
                        getAVtalType={getAVtalType}
                        valueavtaltyp={state.avtaltyp}
                        
                        />
                        </div>
                        <div className="col-6">
                        <Leverantör 
                        getAVtalLeverator={getAVtalLeverator}
                        avtalType={avtalType}
                        valueLeverator={state.Leverantor}
                        />
                        </div>
                    </div>
                    <div className="row my-2"  style={{ height: 'auto' }}>
                        <div className="col-6">
                            <TextField
                                label={<IntlMessages id="Title"/>}
                                name="Rubrik"
                                fullWidth
                                placeholder={Description}
                                size="small"
                                value={state.Rubrik}
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                                onChange={handleChangeR.bind(this)}
                                onBlur={handleBlurR.bind(this)}
                            />
                        </div>
                        {
                           parseInt(props.Flags.PrislistaIkalkyl) === 1?
                           <div className="col-6">
                            <PrislistaInput
                            PrisListId={props.newAvtal.PrisListId}
                            onChange={(e) => PrisListIdChange('PrisListId', e.target.value)}
                            />
                           </div>
                           :"" 
                        }
                        
                        {/*
                        <div className="col-6">
                            <TextField
                                label={<IntlMessages id="input.Value"/>}
                                name="Varde"
                                fullWidth
                                placeholder="SEK"
                                size="small"
                                margin="normal"
                                type="number"
                                value={state.Varde}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                                onChange={handleChangeR.bind(this)}
                                onBlur={handleBlurR.bind(this)}
                            />
                        </div>
                        */}
                    </div>
                    <div className="row my-2"  style={{ height: 'auto' }}>
                        <div className="col-6">
                         <SelectMedArbetare
                         Ansvarig={props.newAvtal.Avtal.Ansvarig}
                         disabled={false}
                         onchangeHanelansvarig={(ansvarig) => getAVtalAnavarig(parseInt(ansvarig))}   
                         />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default injectIntl(InputComponent);
